import type {
  BrowseCategoriesParams,
  BrowseProductsParams,
  CategoryListRequest,
  MediaOwnerType,
  MediaVisibility,
  ProductListRequest,
  ProductSearchRequest,
} from '../model/types';
import type { ListPricingRulesParams, ResolvePriceParams } from '../api/catalogPricingApi';

/** Centralised query keys; everything sits under the `catalog` root so a tenant switch can drop it all. */
export const CATALOG_ROOT_KEY = 'catalog';

export const catalogKeys = {
  all: [CATALOG_ROOT_KEY] as const,

  products: [CATALOG_ROOT_KEY, 'products'] as const,
  productsList: (req: ProductListRequest) => [CATALOG_ROOT_KEY, 'products', 'list', req] as const,
  productsSearch: (req: ProductSearchRequest) =>
    [CATALOG_ROOT_KEY, 'products', 'search', req] as const,
  productsBrowse: (params: BrowseProductsParams) =>
    [CATALOG_ROOT_KEY, 'products', 'browse', params] as const,
  product: (id: string) => [CATALOG_ROOT_KEY, 'products', 'detail', id] as const,
  productPublication: (id: string) =>
    [CATALOG_ROOT_KEY, 'products', 'publication', id] as const,

  categories: [CATALOG_ROOT_KEY, 'categories'] as const,
  categoriesList: (req: CategoryListRequest) =>
    [CATALOG_ROOT_KEY, 'categories', 'list', req] as const,
  categoriesSearch: (params: BrowseCategoriesParams) =>
    [CATALOG_ROOT_KEY, 'categories', 'search', params] as const,
  category: (id: string) => [CATALOG_ROOT_KEY, 'categories', 'detail', id] as const,
  mediaAssets: (params: { ownerType: MediaOwnerType; ownerId?: string; visibility?: MediaVisibility }) =>
    [CATALOG_ROOT_KEY, 'media', 'assets', params] as const,

  pricing: [CATALOG_ROOT_KEY, 'pricing'] as const,
  pricingConfig: [CATALOG_ROOT_KEY, 'pricing', 'config'] as const,
  pricingRules: (params: ListPricingRulesParams) =>
    [CATALOG_ROOT_KEY, 'pricing', 'rules', params] as const,
  providerConfigs: [CATALOG_ROOT_KEY, 'pricing', 'providers'] as const,
  approvals: (params: { page?: number; size?: number }) =>
    [CATALOG_ROOT_KEY, 'pricing', 'approvals', params] as const,
  protectionPolicy: [CATALOG_ROOT_KEY, 'pricing', 'protection-policy'] as const,
  audit: (params: { productId?: string; page?: number; size?: number }) =>
    [CATALOG_ROOT_KEY, 'pricing', 'audit', params] as const,

  salesChannels: [CATALOG_ROOT_KEY, 'pricing', 'sales-channels'] as const,
  priceLines: (productId: string) =>
    [CATALOG_ROOT_KEY, 'pricing', 'price-lines', productId] as const,
  priceResolution: (params: ResolvePriceParams) =>
    [CATALOG_ROOT_KEY, 'pricing', 'resolution', params] as const,

  googleSheet: [CATALOG_ROOT_KEY, 'import', 'google-sheet'] as const,
  importRun: (id: string) => [CATALOG_ROOT_KEY, 'import', 'runs', id] as const,
} as const;
